// extracted by mini-css-extract-plugin
export default {"main":"_28215e690c _739bce4405","xmark":"c103316692","fl_img":"ef8175654e _14114c5f26"};